
import RealTime from '@core/constants/realTime/actions.constants';

export const taskToCashUpdateActions = new Set([
	RealTime.TASK_FINISH,
	RealTime.TASK_CREATE,
	RealTime.TASK_CANCEL,
	RealTime.TASK_UPDATE,

]);